module.exports = __webpack_public_path__ + "static/media/images_section_img6.27774954.png";